import * as React from 'react';
import { observer } from 'mobx-react';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';
import BackgroundImage from '@src/components/background-image';
import DateUtil from '@src/utils/date-util';
import EmptyText from '@src/business-components/empty-text';
import aos from '@src/utils/aos';

const styles = require('../../index.less');

const getHotTopNewsChannels = channelInfo =>
  Object.keys(channelInfo || {})
    .map(key => key.match(/^url_(\d+)_name$/))
    .filter(Boolean)
    .map(match => ({
      index: Number(match[1]),
      name: channelInfo[match[0]],
      urlKey: `url_${match[1]}`
    }))
    .filter(item => String(item.name || '').trim() && String(channelInfo[item.urlKey] || '').trim())
    .sort((a, b) => a.index - b.index);

const News = ({ store }) => {
  store.use();
  const hotTopNewsChannels = getHotTopNewsChannels(store.newChennelInfo);

  return (
    <React.Fragment>
      <div className="main-group-8" data-name="轮播" {...aos.FADE_UP()}>
        <div className="main-layer-22">
          {store.newsImgList?.length > 0 && (
            <BaseSwiper store={store.newsBannerBaseSwiperStore}>
              {store.newsImgList.map((item, index) => {
                return (
                  <Link
                    onClick={() => {
                      store.onNewsItemClick(item, 'swiper');
                    }}
                    className="main-layer-22-item"
                    key={index}
                  >
                    <BackgroundImage src={item.rotating_chart[0]?.url} className="main-layer-22-item-content" />
                  </Link>
                );
              })}
            </BaseSwiper>
          )}
        </div>

        <div className="main-group-9" id="main-group-9" data-name="页码" />
      </div>

      <div className="main-group-10" data-name="页签">
        <Link
          onClick={() => {
            store.onTabClick('最新');
          }}
          className="main-group-11"
          data-name="最新"
        >
          {/* <Link className="main-layer-24" /> */}
          {store.currentTab === '最新' ? <Link className="main-layer-23" /> : <Link className="main-layer-24" />}
        </Link>

        <Link
          onClick={() => {
            store.onTabClick('新闻');
          }}
          className="main-group-12"
          data-name="新 闻"
        >
          {/* <Link className="main-layer-25" /> */}
          {store.currentTab === '新闻' ? <Link className="main-layer-25" /> : <Link className="main-layer-26" />}
        </Link>

        <Link
          onClick={() => {
            store.onTabClick('公告');
          }}
          className="main-group-13"
          data-name="公 告"
        >
          {/* <Link className="main-layer-27" /> */}
          {store.currentTab === '公告' ? <Link className="main-layer-27" /> : <Link className="main-layer-28" />}
        </Link>

        <Link
          onClick={() => {
            store.onTabClick('活动');
          }}
          className="main-group-14"
          data-name="活 动"
        >
          {/* <Link className="main-layer-25" />  */}
          {store.currentTab === '活动' ? <Link className="main-layer-29" /> : <Link className="main-layer-30" />}
        </Link>

        <Link className="main-layer-31" onClick={store.onMoreClick} />
      </div>

      <div
        className="main-layer-32"
        //  {...aos.FADE_UP()}
      />
      <Link
        className="main-group-15"
        data-name="头条新闻"
        onClick={() => {
          store.onNewsItemClick(store.topData);
        }}
        // {...aos.FADE_UP()}
      >
        <div className="main-layer-35" data-name="第二期团长活动即将开启，美女主播诺诺">
          {store.topData?.title || ''}
        </div>

        <div className="main-layer-34" data-name="[客服联系方式] [全新资料片]">
          {hotTopNewsChannels.map(item => (
            <Link
              key={item.urlKey}
              onClick={() => {
                store.openNewTab(item.urlKey);
              }}
            >
              [{item.name}]
            </Link>
          ))}
        </div>

        <div className="main-layer-33" />
      </Link>

      <div className="main-group-16" data-name="列表组" {...aos.FADE_UP()}>
        {store.newsList?.length > 0 ? (
          store.newsList.slice(0, 4).map((item, index) => {
            return (
              <Link
                key={index}
                className="main-group-17"
                data-name="列表1"
                onClick={() => {
                  store.onNewsItemClick(item);
                }}
              >
                <div className="main-layer-38">
                  <BackgroundImage src={require(`./images/${item.categoryName}.png`)} />
                </div>
                <div className="main-layer-37" data-name="S2赛季开启！全新探索“云滇花桥”来啦!">
                  {item.title}
                </div>
                <div className="main-layer-36" data-name="2025-05-25">
                  {DateUtil.formatDate(new Date(item.publishedAt * 1000), 'yyyy-MM-dd')}
                </div>
              </Link>
            );
          })
        ) : (
          <EmptyText />
        )}
      </div>

      <div className="main-layer-48" {...aos.FADE_UP()} />
    </React.Fragment>
  );
};

export default observer(News);
